import StyledTextareaIconButton from '@webclient/components/search-forms/gamification-search/components/search-box-react-hook-form/textarea-icon-button/styles';

import useAppSelector from '@webclient/hooks/useAppSelector';

import SendRoundedIcon from '~icons/knowz-iconify/send';
import WaveAlt2Icon from '~icons/knowz-iconify/wave-alt2-rounded';

import { IconButtonProps } from '@knowz/knowz-ui';

type Props = {
  onChange: (event: React.FormEvent<HTMLButtonElement>) => void;
  onSendMessage?: React.MouseEventHandler<HTMLButtonElement>;
  onVoiceMode: VoidFunction;
  value: string;
} & Omit<IconButtonProps<'button'>, 'value' | 'onChange' | 'onClick' | 'ref'>;

export default function TextareaIconButton({
  onChange,
  value,
  onSendMessage,
  onVoiceMode,
  disabled,
  ...otherProps
}: Props) {
  const attachments = useAppSelector(
    (state) => state.searchSession.attachments,
  );
  const shouldNotRenderVoiceMode =
    value.trim().length > 0 || attachments.length > 0;
  const realTimeMode = useAppSelector(
    (state) => state.searchSession.voiceChatMode.mode,
  );

  const hasValue = value.trim().length > 0;
  const shouldShowStartChat =
    !hasValue && !realTimeMode && !shouldNotRenderVoiceMode;

  function handleVoiceMode() {
    if (disabled) return;
    onVoiceMode();
  }

  return (
    <StyledTextareaIconButton
      {...otherProps}
      disabled={disabled}
      type="button"
      onChange={onChange}
      onClick={shouldNotRenderVoiceMode ? onSendMessage : handleVoiceMode}
    >
      {shouldShowStartChat ? (
        <WaveAlt2Icon />
      ) : (
        <SendRoundedIcon style={{ rotate: '0.75turn' }} />
      )}
    </StyledTextareaIconButton>
  );
}
